module.exports = __webpack_public_path__ + "media/images/icons/filled/carry-out-25b1a867762a6ea4b6506ebec00b220a.svg";